<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
// OverviewView of the admin console — template converted mechanically from design admin-taskcoolV1
// (design/tools/convert_admin_v1.py); values come from renderVals.ts.
import { s, hv } from '../tpl';
defineProps<{ g: any }>();
</script>

<template>
<div :style="s('display:flex; flex-direction:column; gap:18px; animation:apView 220ms ease-out;')">
  <div :style="s('display:flex; gap:2px; padding:3px; border-radius:999px; background:#2a2b2f; align-self:flex-start;')">
    <template v-for="(rg, rg$i) in g.ranges" :key="rg$i">
      <button @click="rg.onClick" :style="s(`height:28px; padding:0 14px; border:none; border-radius:999px; font-family:inherit; font-size:13px; font-weight:700; cursor:pointer; background:${rg.bg}; color:${rg.color};`)">{{ rg.label }}</button>
    </template>
  </div>
  <div :style="s('display:grid; grid-template-columns:repeat(auto-fit, minmax(160px, 1fr)); gap:10px;')">
    <template v-for="(xs, xs$i) in g.ovStats" :key="xs$i">
      <div :style="s('padding:14px 16px; border-radius:12px; background:#2a2b2f; display:flex; flex-direction:column; gap:4px; min-width:0;')">
        <div :style="s('font-size:13px; color:#8a8b91;')">{{ xs.label }}</div>
        <div :style="s('font-size:26px; font-weight:700; line-height:1.25;')">{{ xs.value }}</div>
        <div :style="s('display:flex; gap:6px; align-items:center; font-size:12px; color:#8a8b91;')">
          <span :style="s(`font-weight:700; color:${xs.deltaColor};`)">{{ xs.delta }}</span><span>{{ xs.sub }}</span>
        </div>
      </div>
    </template>
  </div>

  <div :style="s('padding:18px 20px 14px; border-radius:12px; background:#2a2b2f; display:flex; flex-direction:column; gap:12px;')">
    <div :style="s('display:flex; align-items:center; gap:16px; flex-wrap:wrap;')">
      <div :style="s('font-size:16px; font-weight:700; flex:1;')">فعالیت کاربران</div>
      <span :style="s('display:flex; align-items:center; gap:6px; font-size:12px; color:#9c9da3;')"><span :style="s('width:9px; height:9px; border-radius:2px; background:#5d5e64;')"></span>تسک‌های ساخته‌شده</span>
      <span :style="s('display:flex; align-items:center; gap:6px; font-size:12px; color:#9c9da3;')"><span :style="s(`width:9px; height:9px; border-radius:2px; background:${g.accent};`)"></span>تسک‌های انجام‌شده</span>
    </div>
    <div :style="s(`position:relative; height:200px; display:flex; align-items:flex-end; gap:${g.chartGap}; border-bottom:1px solid #45464b; margin-top:14px;`)">
      <div :style="s('position:absolute; left:0; right:0; top:0; border-top:1px dashed #38393e;')"></div>
      <div :style="s('position:absolute; left:0; right:0; top:50%; border-top:1px dashed #38393e;')"></div>
      <span :style="s('position:absolute; left:0; top:-18px; font-size:11px; color:#76777d;')">{{ g.chartMax }}</span>
      <template v-for="(b, b$i) in g.buckets" :key="b$i">
        <div :title="b.title" :style="s('flex:1 1 0; min-width:0; height:100%; display:flex; align-items:flex-end; justify-content:center; gap:2px; cursor:default;')" :class="[hv('background:rgba(255,255,255,0.03);')]">
          <div :style="s(`flex:1 1 0; max-width:14px; height:${b.aH}; background:#5d5e64; border-radius:3px 3px 0 0;`)"></div>
          <div :style="s(`flex:1 1 0; max-width:14px; height:${b.bH}; background:${g.accent}; border-radius:3px 3px 0 0;`)"></div>
        </div>
      </template>
    </div>
    <div :style="s(`display:flex; gap:${g.chartGap};`)">
      <template v-for="(b, b$i) in g.buckets" :key="b$i">
        <div :style="s('flex:1 1 0; min-width:0; text-align:center; font-size:11px; color:#76777d; white-space:nowrap; overflow:visible;')">{{ b.label }}</div>
      </template>
    </div>
  </div>

  <div :style="s('display:grid; grid-template-columns:repeat(auto-fit, minmax(300px, 1fr)); gap:10px;')">
    <div :style="s('padding:18px 20px; border-radius:12px; background:#2a2b2f; display:flex; flex-direction:column; gap:14px;')">
      <div :style="s('font-size:16px; font-weight:700;')">سلامت سیستم</div>
      <div :style="s('display:flex; flex-direction:column; gap:6px;')">
        <div :style="s('display:flex; font-size:13px; color:#9c9da3;')"><span :style="s('flex:1;')">فضای ذخیره‌سازی فایل‌ها</span><span :style="s('color:#e7e7ea; font-weight:500;')">{{ g.storageLabel }}</span></div>
        <div :style="s('height:6px; border-radius:999px; background:#38393e; overflow:hidden;')"><div :style="s(`width:${g.storageW}; height:100%; background:${g.accent}; border-radius:999px;`)"></div></div>
      </div>
      <div :style="s('display:flex; flex-direction:column;')">
        <template v-for="(h, h$i) in g.health" :key="h$i">
          <div :style="s('display:flex; align-items:center; gap:10px; padding:9px 0; border-top:1px solid #34353a; font-size:14px;')">
            <span :style="s(`width:8px; height:8px; border-radius:50%; background:${h.dot};`)"></span>
            <span :style="s('flex:1; color:#c9cacf;')">{{ h.label }}</span>
            <span :style="s('font-family:\'JetBrains Mono\',monospace; font-size:13px; direction:ltr;')">{{ h.value }}</span>
          </div>
        </template>
      </div>
    </div>
    <div :style="s('padding:18px 20px; border-radius:12px; background:#2a2b2f; display:flex; flex-direction:column; gap:12px;')">
      <div :style="s('display:flex; align-items:center;')"><span :style="s('font-size:16px; font-weight:700; flex:1;')">پروژه‌های پرکار</span><a href="#" @click="g.goProjects" :style="s('font-size:13px;')">همه پروژه‌ها</a></div>
      <template v-for="(tp, tp$i) in g.topProjects" :key="tp$i">
        <div :style="s('display:flex; flex-direction:column; gap:5px;')">
          <div :style="s('display:flex; align-items:center; gap:8px; font-size:14px;')">
            <span :style="s(`flex:0 0 12px; width:12px; height:12px; border-radius:50%; border:2px solid ${tp.ring}; box-sizing:border-box;`)"></span>
            <span dir="auto" :style="s('flex:1; min-width:0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;')">{{ tp.name }}</span>
            <span :style="s('font-size:12px; color:#8a8b91;')">{{ tp.val }} تسک</span>
          </div>
          <div :style="s('height:4px; border-radius:999px; background:#34353a;')"><div :style="s(`width:${tp.w}; height:100%; border-radius:999px; background:#8a8b91;`)"></div></div>
        </div>
      </template>
    </div>
    <div :style="s('padding:18px 20px; border-radius:12px; background:#2a2b2f; display:flex; flex-direction:column; gap:4px;')">
      <div :style="s('display:flex; align-items:center; margin-bottom:8px;')"><span :style="s('font-size:16px; font-weight:700; flex:1;')">آخرین رویدادها</span><a href="#" @click="g.goAudit" :style="s('font-size:13px;')">گزارش کامل</a></div>
      <template v-for="(r, r$i) in g.recent" :key="r$i">
        <div :style="s('display:flex; align-items:flex-start; gap:10px; padding:7px 0;')">
          <div :style="s(`flex:0 0 26px; width:26px; height:26px; border-radius:50%; background:${r.av}; color:#fff; font-size:11px; font-weight:700; display:grid; place-items:center;`)">{{ r.initial }}</div>
          <div :style="s('flex:1; min-width:0; font-size:13px; line-height:1.6; color:#c9cacf;')"><b :style="s('color:#e7e7ea; font-weight:500;')">{{ r.actor }}</b> {{ r.action }} <span dir="auto" :style="s('color:#e7e7ea;')">{{ r.target }}</span><div :style="s('font-size:12px; color:#76777d;')">{{ r.time }}</div></div>
        </div>
      </template>
    </div>
  </div>
</div>
</template>
